const getHeaderTag = (headerLayout: number | undefined): string => `h${headerLayout || 2}`
export default getHeaderTag
